/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAmountVo
 */
export interface ServiceAmountVo {
    /**
     * 附加服务id
     * @type {number}
     * @memberof ServiceAmountVo
     */
    additionalServiceId?: number;
    /**
     * 附加服务分组ID
     * @type {number}
     * @memberof ServiceAmountVo
     */
    groupId?: number;
    /**
     * 附加服务名（韩文）
     * @type {string}
     * @memberof ServiceAmountVo
     */
    name?: string;
    /**
     * 附加服务名（中文）
     * @type {string}
     * @memberof ServiceAmountVo
     */
    nameCn?: string;
    /**
     * 附加服务金额
     * @type {number}
     * @memberof ServiceAmountVo
     */
    serviceAmount?: number;
    /**
     * 分成金额
     * @type {number}
     * @memberof ServiceAmountVo
     */
    commissionAmount?: number;
}

/**
 * Check if a given object implements the ServiceAmountVo interface.
 */
export function instanceOfServiceAmountVo(value: object): value is ServiceAmountVo {
    return true;
}

export function ServiceAmountVoFromJSON(json: any): ServiceAmountVo {
    return ServiceAmountVoFromJSONTyped(json, false);
}

export function ServiceAmountVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAmountVo {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'] == null ? undefined : json['additionalServiceId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'serviceAmount': json['serviceAmount'] == null ? undefined : json['serviceAmount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
    };
}

export function ServiceAmountVoToJSON(json: any): ServiceAmountVo {
    return ServiceAmountVoToJSONTyped(json, false);
}

export function ServiceAmountVoToJSONTyped(value?: ServiceAmountVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'serviceAmount': value['serviceAmount'],
        'commissionAmount': value['commissionAmount'],
    };
}

